import * as React from 'react'
import { TablePagination } from '@mui/material';
import objectPath from "object-path";

import { useTable, usePagination, useSortBy } from "react-table";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { LnRouterTableDefinition } from '../node/channelList/table/data/LnRouterTableDefinition';
import ActionButton from '../general/ActionButton';




type Props = {
  className?: string,
  definition: LnRouterTableDefinition<any>,
  rows: any[],
  skip: number,
  limit: number,

  rowsCount: number
  onUserInteraction: (skip: number, limit: number) => any
}


const InternaLiquidityAdsTable: React.FC<Props> = ({ className = '', definition, rows = [], skip, limit, rowsCount, onUserInteraction }) => {
  const [columns, setColumns] = React.useState(definition.reactTableColumns);

  React.useEffect(() => {
    table.setHiddenColumns(definition.columns.filter(c => !c.options.enabled).map(c => c.valuePath))
  }, [columns]);

  React.useEffect(() => {
    setColumns(definition.reactTableColumns);
  }, [definition])

  const table = useTable({
    columns,
    data: rows,
    initialState: {
      pageIndex: 0,
      pageSize: limit,
    },
    manualPagination: true,

  }, usePagination)

  const hoverRowEffectClasses = 'hover:bg-viking-100 border-l-4 border-transparent hover:border-viking-700';

  const headerClass = "text-left text-sm text-gray-500 pb-1 font-medium";
  return (
    <div>
      <table className={className + " relative  "}>
        <thead>
          {// Loop over the header rows
            table.headerGroups.map(headerGroup => {
              const isTopHeader = !headerGroup.headers[0].Cell;
              return (
                // Apply the header row props
                <tr {...headerGroup.getHeaderGroupProps()} className={headerClass + ` ${!isTopHeader ? 'border-b ' : ''}`}>
                  {// Loop over the headers in each row
                    headerGroup.headers.map(column => (
                      // Apply the header cell props
                      <th {...column.getHeaderProps()} className={``}>
                        {!column.Cell &&
                          column.render('Header')
                        }
                        {column.Cell &&
                          column.render('Header')
                        }
                      </th>
                    ))}
                </tr>
              )
            })}
        </thead>
        <tbody>
          {// Loop over the table rows
            table.page.map((row, rowIndex) => {
              // Prepare the row for display
              table.prepareRow(row)
              return (
                // Apply the row props
                <tr {...row.getRowProps()} className={`${hoverRowEffectClasses}  ` + (rowIndex % 2 === 0 ? 'bg-gray-100' : '')} >
                  {// Loop over the rows cells
                    row.cells.map(cell => {
                      // Apply the cell props
                      return (
                        <td {...cell.getCellProps()} className="py-1">
                          {// Render the cell contents
                            cell.render('Cell')
                          }
                        </td>
                      )
                    })}
                </tr>
              )
            })}
        </tbody>
      </table>
    </div>
  );
}

export default InternaLiquidityAdsTable;

